var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pad-child",attrs:{"align":"center"}},[(_vm.hasClientRoles(['manager']))?_c('div',[_c('UsersByRolePage')],1):_c('StandardRedirect',{attrs:{"targetRoute":'/'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }